

module.exports = __webpack_require__.stylable.create(
    "SkeletonRectangle1853579400",
    {"classes":{"root":"SkeletonRectangle1853579400__root"},"vars":{},"stVars":{},"keyframes":{}},
    ".SkeletonRectangle1853579400__root{position:relative;overflow:hidden;border-radius:6px;max-width:690px}",
    3,
    "SkeletonRectangle1853579400",
    __webpack_require__.stylable.$
);
